import { tauriBridge } from './tauri';
import { webBridge } from './web';
import type { ActivityBridge } from './types';

export * from './types';
export { tauriBridge } from './tauri';
export { webBridge } from './web';
export * from './auth';

export function isTauriEnvironment(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof (window as Window & { __TAURI_INTERNALS__?: unknown }).__TAURI_INTERNALS__ !==
      'undefined'
  );
}

export function getActivityBridge(): ActivityBridge {
  return isTauriEnvironment() ? tauriBridge : webBridge;
}

export const desktopBridge: ActivityBridge = getActivityBridge();
